import { setStore } from "@/config/storage";

export default {
	// 登录
	login(state, userInfo = null) {
		if (userInfo && userInfo.token) {
			state.login = true
			setStore('costUserInfo', userInfo);
		} else {
			state.login = false
			setStore('costUserInfo', '');
		}
		state.userInfo = userInfo
	},
	setEditStep(state, data) {
		state.editStep = data
	},
	// 退出登录
	logout(state) {
		state.login = false
		setStore('costUserInfo', '');
	},
	// 登录重定向
	loginRedirect(state, path) {
		state.loginRedirect = path
	}
}